import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import WorldWireframeMap from './WorldWireframeMap';
import { SiteData } from '../types';

interface GeographicDataModalProps {
  isOpen: boolean;
  onClose: () => void;
  siteData: SiteData[];
}

export const GeographicDataModal = ({ isOpen, onClose, siteData }: GeographicDataModalProps) => {
  const handleModalClose = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleModalClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Global Network - Geographic Data</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <WorldWireframeMap 
            height={600}
            stroke="hsl(var(--primary))"
            hoverStroke="hsl(var(--secondary))"
            showGraticule={true}
            showPoints={true}
            pointCount={180}
            siteData={siteData}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};